import { LocationState } from 'history';
import { config } from '../../config';
import history from '../routing/history';

export function navigateTo(url: string) {
  if (config.isStorybook) {
    console.log('Navigate to:', url);
    return;
  }

  window.location.href = url;
}

export function pushTo(path: string, replace = false, state?: LocationState) {
  if (replace) {
    history.replace(path, state);
  } else {
    history.push(path, state);
  }
}
